import React, { useState } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Contact form submitted:", formData);
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    }, 3000);
  };

  return (
    <>
      <Helmet>
        <title>AgroHarvest | Contact Us</title>
        <meta
          name="description"
          content="Get in touch with AgroHarvest Machineries for inquiries, quotes, and support."
        />
      </Helmet>
      <TheContactUs>
        <div className="contact-hero">
          <div className="hero-inner">
            <span className="hero-label">
              AgroHarvest Machineries — Hopkinsville, Kentucky
            </span>
            <h1>Contact Us</h1>
            <p className="hero-sub">
              Get in touch with our team for any inquiries or support.
            </p>
          </div>
          <div className="hero-rule" />
        </div>

        <div className="contact-container">
          <div className="info-col">
            <span className="section-tag">Get In Touch</span>
            <p className="info-lead">
              Have questions about our equipment? Need a quote? Our team is
              ready to help you find the right machine at the right price.
            </p>

            <div className="info-rows">
              <div className="info-row">
                <span className="info-label">Email</span>
                <div className="info-body">
                  <a href="mailto:support@agroharvest.com">
                    support@agroharvest.com
                  </a>
                  <p>Response within 24 hours</p>
                </div>
              </div>
              <div className="info-row">
                <span className="info-label">Phone</span>
                <div className="info-body">
                  <a href="tel:+12706320751"> +1-(270)-632-0751</a>
                  <p>Mon–Fri: 8am – 6pm CST</p>
                </div>
              </div>
              <div className="info-row">
                <span className="info-label">Address</span>
                <div className="info-body">
                  <p>
                    8 Cadiz Rd, Hopkinsville
                    <br />
                    KY 42240, United States
                  </p>
                </div>
              </div>
              <div className="info-row">
                <span className="info-label">Hours</span>
                <div className="info-body">
                  <p>Monday – Friday: 9:00 AM – 6:00 PM</p>
                  <p>Saturday: 9:00 AM – 2:00 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          <div className="form-col">
            <span className="section-tag">Send a Message</span>

            {formSubmitted ? (
              <div className="success-state">
                <span className="success-mark">&#10003;</span>
                <h3>Message Sent</h3>
                <p>
                  Thank you for reaching out. Our team will get back to you
                  shortly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">
                      Full Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">
                      Email Address <span className="req">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="(555) 555-5555"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">
                      Subject <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="Equipment Inquiry"
                    />
                  </div>
                </div>

                <div className="form-group full">
                  <label htmlFor="message">
                    Message <span className="req">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Please provide details about your inquiry..."
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="map-section">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3225.4567890123456!2d-87.4912345678901!3d36.85678901234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8865a12345678901%3A0x1234567890abcdef!2s8%20Cadiz%20Rd%2C%20Hopkinsville%2C%20KY%2042240!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="AgroHarvest Location"
          />
        </div>
      </TheContactUs>
    </>
  );
};

const TheContactUs = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f5f2ed;
  font-family: "Georgia", "Times New Roman", serif;
  color: #1c1c1c;

  /* ── HERO ── */
  .contact-hero {
    background: var(--primary-color);
    padding: 7rem 6rem 4rem;

    .hero-inner {
      max-width: 900px;

      .hero-label {
        display: block;
        font-family: "Courier New", monospace;
        font-size: 0.75rem;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.5);
        margin-bottom: 2rem;
      }

      h1 {
        font-size: clamp(3rem, 8vw, 6.5rem);
        font-weight: 400;
        color: #f5f2ed;
        line-height: 1;
        letter-spacing: -0.02em;
        margin: 0 0 1.8rem;
      }

      .hero-sub {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.55);
        font-style: italic;
        letter-spacing: 0.03em;
        margin: 0;
      }
    }

    .hero-rule {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
      margin-top: 4rem;
    }
  }

  /* ── MAIN CONTAINER ── */
  .contact-container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 5rem 4rem;
    display: grid;
    grid-template-columns: 1fr 1.4fr;
    gap: 6rem;
    align-items: start;
  }

  .section-tag {
    display: inline-block;
    font-family: "Courier New", monospace;
    font-size: 0.7rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #7a7265;
    margin-bottom: 1.5rem;
  }

  /* ── INFO COLUMN ── */
  .info-col {
    .info-lead {
      font-size: 1rem;
      line-height: 1.8;
      color: #3d3d3d;
      margin-bottom: 2.5rem;
    }

    .info-rows {
      display: flex;
      flex-direction: column;

      .info-row {
        display: grid;
        grid-template-columns: 80px 1fr;
        gap: 1.5rem;
        padding: 1.4rem 0;
        border-bottom: 1px solid #d5d0c8;
        align-items: start;

        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          border-bottom: none;
        }

        .info-label {
          font-family: "Courier New", monospace;
          font-size: 0.7rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--primary-color);
          padding-top: 0.15rem;
        }

        .info-body {
          a {
            display: block;
            font-size: 0.98rem;
            color: #1c1c1c;
            text-decoration: none;
            margin-bottom: 0.25rem;
            transition: color 0.2s;

            &:hover {
              color: var(--primary-color);
            }
          }

          p {
            font-size: 0.88rem;
            color: #666;
            line-height: 1.6;
            margin: 0 0 0.15rem;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  /* ── FORM COLUMN ── */
  .form-col {
    .success-state {
      padding: 3rem 0;
      border-top: 1px solid #d5d0c8;

      .success-mark {
        display: block;
        font-size: 1.5rem;
        color: var(--primary-color);
        margin-bottom: 1rem;
        font-family: "Courier New", monospace;
      }

      h3 {
        font-size: 1.6rem;
        font-weight: 400;
        color: var(--primary-color);
        margin: 0 0 0.6rem;
      }

      p {
        font-size: 0.95rem;
        color: #666;
        line-height: 1.7;
        margin: 0;
      }
    }

    form {
      border-top: 1px solid #d5d0c8;
      padding-top: 1.5rem;

      .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.2rem;
        margin-bottom: 1.2rem;
      }

      .form-group {
        display: flex;
        flex-direction: column;
        gap: 0.45rem;

        &.full {
          grid-column: span 2;
        }

        label {
          font-family: "Courier New", monospace;
          font-size: 0.7rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--primary-color);

          .req {
            color: #999;
            margin-left: 2px;
          }
        }

        input,
        textarea {
          padding: 0.75rem 1rem;
          border: 1px solid #d5d0c8;
          border-radius: 0;
          background: #fff;
          font-size: 0.95rem;
          font-family: "Georgia", serif;
          color: #1c1c1c;
          transition:
            border-color 0.2s,
            box-shadow 0.2s;

          &::placeholder {
            color: #b0a898;
          }

          &:focus {
            outline: none;
            border-color: var(--primary-color);
            box-shadow: 0 0 0 2px rgba(26, 71, 42, 0.08);
          }
        }

        textarea {
          resize: vertical;
        }
      }

      .submit-btn {
        margin-top: 0.8rem;
        display: inline-block;
        background: transparent;
        color: var(--primary-color);
        border: 1px solid var(--primary-color);
        padding: 0.8rem 2.2rem;
        font-family: "Courier New", monospace;
        font-size: 0.78rem;
        letter-spacing: 0.15em;
        text-transform: uppercase;
        cursor: pointer;
        transition: all 0.25s ease;

        &:hover {
          background: var(--primary-color);
          color: #f5f2ed;
        }
      }
    }
  }

  /* ── MAP ── */
  .map-section {
    width: 100%;
    height: 420px;
    overflow: hidden;
    border-top: 1px solid #d5d0c8;

    iframe {
      width: 100%;
      height: 100%;
      filter: grayscale(0.3);
      transition: filter 0.3s ease;
      display: block;

      &:hover {
        filter: grayscale(0);
      }
    }
  }

  /* ── RESPONSIVE ── */
  @media screen and (max-width: 1024px) {
    .contact-hero {
      padding: 5rem 3rem 3rem;
    }
    .contact-container {
      padding: 4rem 3rem;
      gap: 4rem;
    }
  }

  @media screen and (max-width: 768px) {
    .contact-hero {
      padding: 4rem 2rem 2.5rem;
      h1 {
        font-size: 3rem;
      }
    }
    .contact-container {
      grid-template-columns: 1fr;
      padding: 3rem 2rem;
      gap: 3rem;
    }
    .map-section {
      height: 380px;
    }
  }

  @media screen and (max-width: 600px) {
    .contact-hero {
      padding: 3rem 1.5rem 2rem;
      h1 {
        font-size: 2.4rem;
      }
    }
    .contact-container {
      padding: 2.5rem 1.5rem;
    }
    .form-col form .form-row {
      grid-template-columns: 1fr;
    }
    .form-col form .form-group.full {
      grid-column: span 1;
    }
    .map-section {
      height: 320px;
    }
  }

  @media screen and (max-width: 420px) {
    .contact-hero {
      padding: 2.5rem 1.2rem 1.8rem;
      h1 {
        font-size: 2rem;
      }
    }
    .contact-container {
      padding: 2rem 1.2rem;
    }
    .info-col .info-rows .info-row {
      grid-template-columns: 1fr;
      gap: 0.4rem;
    }
    .map-section {
      height: 270px;
    }
  }

  @media screen and (max-width: 350px) {
    .contact-hero h1 {
      font-size: 1.7rem;
    }
  }
`;

export default ContactUs;
